import { GetMaxBagsCountResponse, GetChosenBagsCountResponse, UseXmasInterface } from './types';
import { Logger } from '@vue-storefront/core';
import { useApi } from '~/composables/useApi';
import updateQtyQuery from '../../queries/updateQty';
import getMaxBagsCountQuery from '../../queries/getMaxBagsCount';
import getChosenBagsCountQuery from '../../queries/getChosenBagsCount';
import useCart from '~/modules/core/composables/useCart';
import { Cart, useUiNotification } from "~/composables";
import { readonly, ref } from "@nuxtjs/composition-api";

export const useXmas = (): UseXmasInterface => {
  const { send: sendNotification } = useUiNotification();
  const { query, mutate } = useApi();
  const { cart, setCart, mergeCartItems } = useCart();
  const loading = ref(false);
  const chosenBagsCount = ref(0);
  const maxBagsCount = ref(0);

  const getMaxBagsCount = async () => {
    const cart_id = cart.value?.id;
    Logger.debug('useXmas/getMaxBagsCount', cart_id);
    try {
      const { data }: GetMaxBagsCountResponse = await query(getMaxBagsCountQuery, {
        cart_id
      });

      if (data && !isNaN(data.xmasGetMaxBagsCount)) {
        maxBagsCount.value = data.xmasGetMaxBagsCount;
      }
    } catch (err) {
      Logger.error('useXmas/getMaxBagsCount', err);
      console.error(err);
    }
  }

  const getChosenBagsCount = async () => {
    const cart_id = cart.value?.id;
    Logger.debug('useXmas/getChosenBagsCount', cart_id);
    try {
      const { data }: GetChosenBagsCountResponse = await query(getChosenBagsCountQuery, {
        cart_id
      });

      if (data && !isNaN(data.xmasGetChosenBagsCount)) {
        chosenBagsCount.value = data.xmasGetChosenBagsCount;
      }
    } catch (err) {
      Logger.error('useXmas/getChosenBagsCount', err);
      console.error(err);
    }
  }

  const updateQty = async (qty) => {
    const cart_id = cart.value?.id;
    Logger.debug('useXmas/updateQty', [cart_id, qty]);
    loading.value = true;
    try {
      const { data, errors } = await mutate(updateQtyQuery, {
        cart_id: cart_id,
        qty: qty
      });

      if (errors) {
        if (Array.isArray(errors)) {
          sendNotification({
            icon: 'error',
            id: Symbol(''),
            message: errors[0].message,
            persist: false,
            title: 'Update error',
            type: 'danger',
            area: 'top'
          })
        }
      } else {
        //@ts-ignore
        const updatedCart = data.xmasUpdateQty.cart as unknown as Cart;
        //@ts-ignore
        setCart(mergeCartItems(updatedCart));
      }
    } catch (err) {
      Logger.error('useXmas/updateQty', err);
      console.error(err);
    } finally {
      loading.value = false;
    }
  };

  return {
    getMaxBagsCount,
    getChosenBagsCount,
    updateQty,
    loading: readonly(loading),
    maxBagsCount: readonly(maxBagsCount),
    chosenBagsCount: readonly(chosenBagsCount)
  };
};
